import { useState } from "react";

export type DataViewProps<T> = {
    data: T | undefined,
    setData: (data: T | undefined) => void,
};

export function useStatefulDataView<T>(data?: T): DataViewProps<T> {
    const state = useState<T | undefined>(data);
    return { data: state[0] || data, setData: state[1] };
}

export type ClickableProps<T> = { onClick?: (data: T) => void };
// export type SelectableProps<T> = { onSelected?: (data: T) => void };

// export type ListProps<T extends Identifiable> = DataViewProps<T[]>;
// export type ItemSelectableProps<T> = { onSelectedItem?: (Item: T) => void };

const doNothing = () => { };
export const readOnly = { setData: doNothing };
export function useReadOnly<T>(data?: T): DataViewProps<T> {
    return { data, setData: doNothing };
}